import { createContext, useContext } from 'react';
import { IIndustry } from 'src/services/industries';

export interface IIndustriesContext {
	isLoading: boolean;
	error: Error | null;
	getIndustries: () => Promise<IIndustry[]>;
}

const IndustriesContext = createContext<IIndustriesContext | undefined>(
	undefined,
);

export const useIndustriesContext = () => {
	const ctx = useContext(IndustriesContext);
	if (!ctx)
		throw new Error(
			'useIndustriesContext must be used within an IndustriesProvider',
		);
	return ctx;
};

export { IndustriesContext };
